import React, { FC } from "react";
import { useAppContext } from "../../Unknown/AppContext";
import useRows from "./useRows";
import AppointmentOfferingTableGrid from "../AppointmentOfferingTableGrid";
import { DashboardAppointmentOffering } from "../AppointmentOfferingTableContainer/getAppointmentOfferings";
import { ShowReadSwitchProps } from "../AppointmentOfferingTableTopBar";
import { GridSortItem } from "../../Unknown/DataGrid";
import getOptionalArrayItem from "../../../common/getOptionalArrayItem";

type AppointmentOfferingRoleTableProps = {
  role: string | undefined;
  appointmentOfferings: DashboardAppointmentOffering[];
  isLoading: boolean;
  showReadProps: ShowReadSwitchProps;
  sortModel: GridSortItem[];
  setSortModel: (newModel: GridSortItem[]) => void;
};

const AppointmentOfferingRoleTable: FC<AppointmentOfferingRoleTableProps> = ({
  role,
  appointmentOfferings,
  isLoading,
  showReadProps,
  sortModel,
  setSortModel,
}) => {
  const { databaseUserData } = useAppContext();

  const rows = useRows(appointmentOfferings);

  if (!databaseUserData || !databaseUserData.centerIds) return null;

  const localeFormat =
    databaseUserData.centerIds.length === 1 ? "center" : "client";

  if (
    !role ||
    !["receptionist", "radiologist", "technologist"].includes(role)
  ) {
    return null;
  }

  return (
    <AppointmentOfferingTableGrid
      columnsConfig={{
        columnItems: [
          { field: "alert", isDeliveryShown: true },
          { field: "status" },
          { field: "patient", localeFormat },
          { field: "time", localeFormat },
          { field: "location" },
          { field: "offering" },
          { field: "notes" },
          { field: "btnView" },
          ...getOptionalArrayItem(role === "radiologist", {
            field: "btnOptions" as const,
          }),
        ],
      }}
      sortModel={sortModel}
      setSortModel={setSortModel}
      rows={rows}
      isLoading={isLoading}
      showReadProps={showReadProps}
    />
  );
};

export default AppointmentOfferingRoleTable;
